import { ResponseType, Submit } from "../../../hooks/use-chat";
import { Message } from "../../../hooks/use-chat";
import { Swap, } from "./swap-quote";
import { TransactionStatus } from "./transaction-status";
import { SelectOptionView } from "./select-option";
import { SignTransactionView } from "./sign-transaction";
import { SignMessageView } from "./sign-message";

export interface RenderComponentProps {
    component: string;
    data: any;
    submit: (data: Submit) => void;
    setMessages: React.Dispatch<React.SetStateAction<Message[]>>;
    accessToken: string;
    setError: React.Dispatch<React.SetStateAction<string>>;
    sendMessageHidden: (message: string) => void;
    sendUserSignature: (signature: string) => Promise<void>;
}

export const RenderComponent = ({
    component,
    data,
    setMessages,
    accessToken,
    setError,
    sendMessageHidden,
    sendUserSignature
}: RenderComponentProps) => {
    const message = data?.data || data

    switch (component) {
        case ResponseType.SELECT_OPTION:
            return <SelectOptionView message={message} sendMessageHidden={sendMessageHidden} />;
        case ResponseType.SIGN_AND_SUBMIT_TRANSACTION:
            return <SignTransactionView message={message} setMessages={setMessages} accessToken={accessToken} setError={setError} />;
        case ResponseType.SIGN_MESSAGE:
            return (
                <SignMessageView message={message} sendUserSignature={sendUserSignature} />
            );
        case ResponseType.SWAP:
            return <Swap message={message} setMessages={setMessages} accessToken={accessToken} setError={setError} />;
        case ResponseType.TRANSACTION_STATUS:
            return <TransactionStatus message={message} />;
        default:
            return (
                <pre className="break-words whitespace-pre-wrap">
                    Error: No component called {component}
                </pre>
            );
    }
};
